module.exports = __webpack_public_path__ + "static/media/REDSYS-COMPRA-SEGURA2.1efa5db2.png";